import type { ComponentProps } from 'react';

import { ModuleIcon } from '#components/Icon/ModuleIcon';
import type { ModuleType } from '#types/global';

import styles from './ArticleType.module.scss';

type Props = {
	moduleType: ModuleType | undefined | null;
	iconSize?: ComponentProps<typeof ModuleIcon>['size'];
	className?: string;
};
export function ArticleType({ className = '', moduleType, iconSize }: Props) {
	let title = null;

	switch (moduleType) {
		case 'AUDIO':
			title = 'Audiobeitrag';
			break;

		case 'VIDEO':
			title = 'Videobeitrag';
			break;

		case 'LIVESTREAM':
			title = 'Livebeitrag';
			break;

		case 'IMAGE':
			title = 'Bildbeitrag';
			break;
		default:
			return;
	}

	return (
		<div className={`${styles.root} ${className}`}>
			<ModuleIcon className={styles.icon} moduleType={moduleType} size={iconSize} />
			{title}
		</div>
	);
}
